import * as React from 'react';
import { Divider, Form, Message, Modal } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { ModalEnfocable } from 'src/componentes/semantic-ui-extended';
import { Contexto } from 'src/contexto';

interface NombrePersonal {
    readonly primerNombre: string;
    readonly nombresSecundarios: string;
    readonly apellidoPaterno: string;
    readonly apellidoMaterno: string;
}

interface Props {
    modalAbierto: boolean;
    alCerrar(): void;
    alRegistrarProfesor(idNuevoProfesor: string): void;
}

interface State extends NombrePersonal {
    cargando: boolean;
}

function capitalizar(texto: string) {
    return texto.toLowerCase().replace(/(?:^|\s)\S/g, s => s.toUpperCase());
}

const stateInicial: State = {
    primerNombre: '',
    nombresSecundarios: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    cargando: false,
};

class ModalNuevoProfesor extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public readonly state: State = { ...stateInicial };

    public render() {
        const { modalAbierto, alCerrar } = this.props;
        const { cargando } = this.state;

        return (
            <ModalEnfocable open={modalAbierto} closeIcon closeOnEscape onClose={alCerrar}>
                <Modal.Header>Nuevo profesor</Modal.Header>

                <Modal.Content>
                    <Message info>
                        Se creará también un usuario para el profesor. Prefiera ingresar los dos
                        apellidos pues formarán parte del nombre de usuario.
                    </Message>

                    <Form loading={cargando} onSubmit={this.registrarProfesor}>
                        <Form.Group widths='2'>
                            <Form.Input
                                required
                                label='Primer nombre'
                                placeholder='Anaxímenes'
                                value={this.state.primerNombre}
                                onChange={(_e, { value }) => {
                                    this.setState({ primerNombre: capitalizar(value) });
                                }}
                            />
                            <Form.Input
                                label='Nombres secundarios'
                                placeholder='Pascual Alfonsero'
                                value={this.state.nombresSecundarios}
                                onChange={(_e, { value }) => {
                                    this.setState({ nombresSecundarios: capitalizar(value) });
                                }}
                            />
                        </Form.Group>

                        <Form.Group widths='2'>
                            <Form.Input
                                required
                                label='Apellido Paterno'
                                placeholder='González'
                                value={this.state.apellidoPaterno}
                                onChange={(_e, { value }) => {
                                    this.setState({ apellidoPaterno: capitalizar(value) });
                                }}
                            />
                            <Form.Input
                                label='Apellido Materno'
                                placeholder='Pérez'
                                value={this.state.apellidoMaterno}
                                onChange={(_e, { value }) => {
                                    this.setState({ apellidoMaterno: capitalizar(value) });
                                }}
                            />
                        </Form.Group>

                        <Divider />

                        <Form.Button
                            primary
                            content='Registrar profesor'
                            disabled={cargando}
                            type='submit'
                        />
                    </Form>
                </Modal.Content>
            </ModalEnfocable>
        );
    }

    private readonly registrarProfesor = () => {
        const { alRegistrarProfesor } = this.props;
        const { cargando: _, ...nombre } = this.state;

        this.setState({ cargando: true });

        clienteApi
            .ejecutar('registrarProfesor', { nombre })
            .then(id => {
                this.setState({ ...stateInicial });
                alRegistrarProfesor(id);
            })
            .catch(error => {
                this.setState({ cargando: false });
                this.context.mostrarModalError(error);
            });
    };
}

export default ModalNuevoProfesor;



// WEBPACK FOOTER //
// ./src/modulos/Horarios/DetalleDelCurso/Informacion/ModalNuevoProfesor.tsx